import axios from 'axios';
import type { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
export const encode = (param: string) => encodeURIComponent(encodeURIComponent(encodeURIComponent(param)));

export const setupAuthentication = (token: string) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};
